import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import ptTranslations from './locales/pt.json';
import { parameterData } from './utils/parameterData';
import { parameterDataPt } from './utils/parameterDataPt';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
        parameterData: parameterData
      },
      pt: {
        translation: ptTranslations,
        parameterData: parameterDataPt
      },
    },
    lng: 'en', // língua padrão
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
